import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55fdc224"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "操作教學", -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode("我已儲存的設計")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("更改寵物")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("重設此設計")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("複製此設計")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("操作說明")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 新設計 ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("更改木牌字")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("翻動")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("縮小")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("放大")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("移上一層")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("移下一層")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("顯示")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("隱藏")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("刪除")
const _hoisted_17 = ["src"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " ", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " ", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " ", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " ", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " ", -1))
const _hoisted_23 = /*#__PURE__*/_createTextVNode("提交你的設計")
const _hoisted_24 = ["src"]
const _hoisted_25 = /*#__PURE__*/_createTextVNode("您的名字*")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("您的WhatsApp號碼*")
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" 確認提交 ")
const _hoisted_28 = { ref: "topElRef" }
const _hoisted_29 = {
  key: 0,
  class: "spin"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "素材載入中...", -1))
const _hoisted_31 = {
  ref: "stageParentRef",
  style: {"letter-spacing":"normal"}
}
const _hoisted_32 = {
  key: 0,
  class: "ion-margin-bottom"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" 解除指定 ")
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" 指定移動 ")
const _hoisted_36 = {
  key: 1,
  class: "horizontal-scroll"
}
const _hoisted_37 = /*#__PURE__*/_createTextVNode("寵物")
const _hoisted_38 = /*#__PURE__*/_createTextVNode("主花")
const _hoisted_39 = /*#__PURE__*/_createTextVNode("副花")
const _hoisted_40 = { ref: "shapePanelRef" }
const _hoisted_41 = { class: "main-div" }
const _hoisted_42 = /*#__PURE__*/_createTextVNode("已選")
const _hoisted_43 = /*#__PURE__*/_createTextVNode("主花")
const _hoisted_44 = /*#__PURE__*/_createTextVNode("副花")
const _hoisted_45 = /*#__PURE__*/_createTextVNode("草皮")
const _hoisted_46 = /*#__PURE__*/_createTextVNode("裝飾品")
const _hoisted_47 = { class: "grey-bg color-buttons" }
const _hoisted_48 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_49 = { class: "flower-div" }
const _hoisted_50 = ["src"]
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_52 = ["src"]
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_54 = { class: "selected-shapes-bar ion-text-center" }
const _hoisted_55 = { class: "flower-list ion-no-margin" }
const _hoisted_56 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_popover = _resolveComponent("ion-popover")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_segment_button = _resolveComponent("ion-segment-button")!
  const _component_ion_segment = _resolveComponent("ion-segment")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_list_header = _resolveComponent("ion-list-header")!
  const _component_ion_thumbnail = _resolveComponent("ion-thumbnail")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_v_rect = _resolveComponent("v-rect")!
  const _component_v_layer = _resolveComponent("v-layer")!
  const _component_v_image = _resolveComponent("v-image")!
  const _component_v_text = _resolveComponent("v-text")!
  const _component_v_group = _resolveComponent("v-group")!
  const _component_v_transformer = _resolveComponent("v-transformer")!
  const _component_v_stage = _resolveComponent("v-stage")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_chip = _resolveComponent("ion-chip")!
  const _component_ion_badge = _resolveComponent("ion-badge")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_grid, { fixed: "" }, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(_component_ion_toolbar, null, {
                default: _withCtx(() => [
                  _withDirectives(_createVNode(_component_ion_buttons, { slot: "start" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        color: "primary",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.leaveDesign()))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            slot: "icon-only",
                            icon: $setup.chevronBack
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 512), [
                    [_vShow, !$setup.viewOnly]
                  ]),
                  _createVNode(_component_ion_title, { style: {"padding-inline":"unset"} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => [
                          _createElementVNode("p", null, _toDisplayString($setup.design.name), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _withDirectives(_createVNode(_component_ion_buttons, { slot: "primary" }, {
                    default: _withCtx(() => [
                      _withDirectives(_createVNode(_component_ion_button, {
                        color: "tertiary",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.openHelpModal()))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            slot: "start",
                            icon: $setup.helpCircleOutline
                          }, null, 8, ["icon"]),
                          _hoisted_1
                        ]),
                        _: 1
                      }, 512), [
                        [_vShow, $setup.design.id == null]
                      ]),
                      _withDirectives(_createVNode(_component_ion_button, {
                        color: "primary",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.shareCanvas()))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            slot: "icon-only",
                            icon: $setup.shareOutline
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }, 512), [
                        [_vShow, $setup.design.id]
                      ]),
                      _createVNode(_component_ion_button, {
                        color: "primary",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.saveCanvas($setup.design)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            slot: "icon-only",
                            icon: $setup.save
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_button, {
                        onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.setPopoverOpen(true, $event)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            slot: "icon-only",
                            ios: $setup.ellipsisHorizontal,
                            md: $setup.ellipsisVertical
                          }, null, 8, ["ios", "md"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_popover, {
                        "is-open": $setup.isPopoverOpenRef,
                        event: $setup.popoverEvent,
                        onDidDismiss: _cache[10] || (_cache[10] = ($event: any) => ($setup.setPopoverOpen(false))),
                        "dismiss-on-select": true
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_content, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_list, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_item, {
                                    onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.openDesignListModal())),
                                    button: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_icon, {
                                        slot: "start",
                                        icon: $setup.folderOutline
                                      }, null, 8, ["icon"]),
                                      _createVNode(_component_ion_label, null, {
                                        default: _withCtx(() => [
                                          _hoisted_2
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_item, {
                                    onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.openDesignPreQuestionModal())),
                                    button: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_icon, {
                                        slot: "start",
                                        icon: $setup.pencil
                                      }, null, 8, ["icon"]),
                                      _createVNode(_component_ion_label, null, {
                                        default: _withCtx(() => [
                                          _hoisted_3
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_item, {
                                    onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.clearCanvasShapes())),
                                    button: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_icon, {
                                        slot: "start",
                                        icon: $setup.refresh
                                      }, null, 8, ["icon"]),
                                      _createVNode(_component_ion_label, null, {
                                        default: _withCtx(() => [
                                          _hoisted_4
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_item, {
                                    onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.cloneDesign($setup.design))),
                                    button: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_icon, {
                                        slot: "start",
                                        icon: $setup.copyOutline
                                      }, null, 8, ["icon"]),
                                      _createVNode(_component_ion_label, null, {
                                        default: _withCtx(() => [
                                          _hoisted_5
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_item, {
                                    onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.openHelpModal())),
                                    lines: "none",
                                    button: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_icon, {
                                        slot: "start",
                                        icon: $setup.helpCircleOutline
                                      }, null, 8, ["icon"]),
                                      _createVNode(_component_ion_label, null, {
                                        default: _withCtx(() => [
                                          _hoisted_6
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["is-open", "event"])
                    ]),
                    _: 1
                  }, 512), [
                    [_vShow, !$setup.viewOnly && !($setup.loadingCanvas || $setup.loadingUserDesigns)]
                  ]),
                  _withDirectives(_createVNode(_component_ion_buttons, { slot: "primary" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        color: "primary",
                        fill: "outline",
                        onClick: _cache[11] || (_cache[11] = ($event: any) => ($setup.goToHomePageWithDesignModal()))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            slot: "start",
                            icon: $setup.add
                          }, null, 8, ["icon"]),
                          _hoisted_7
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 512), [
                    [_vShow, $setup.viewOnly]
                  ])
                ]),
                _: 1
              }, 512), [
                [_vShow, !$setup.canvas.selectedShape.id]
              ]),
              _withDirectives(_createVNode(_component_ion_toolbar, { class: "ion-text-center" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _withDirectives(_createVNode(_component_ion_segment, {
                      style: {"height":"48px"},
                      modelValue: $setup.dummy,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (($setup.dummy) = $event)),
                      onIonChange: _cache[22] || (_cache[22] = ($event: any) => ($setup.dummy = 'dummy')),
                      scrollable: ""
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createVNode(_component_ion_segment_button, {
                          mode: "md",
                          onClick: _cache[12] || (_cache[12] = ($event: any) => ($setup.presentNamePlateTextInput()))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_icon, { icon: $setup.createOutline }, null, 8, ["icon"]),
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [
                                _hoisted_8
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 512), [
                          [_vShow, $setup.canvas.selectedShape.name == '木名牌']
                        ]),
                        _withDirectives(_createVNode(_component_ion_segment_button, {
                          mode: "md",
                          onClick: _cache[13] || (_cache[13] = ($event: any) => ($setup.flipSelectedShape())),
                          disabled: $setup.canvas.isFlipping
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_icon, { icon: $setup.swapHorizontal }, null, 8, ["icon"]),
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [
                                _hoisted_9
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["disabled"]), [
                          [_vShow, $setup.canvas.selectedShape.type != '寵物' && $setup.canvas.selectedShape.name != '木名牌']
                        ]),
                        _withDirectives(_createVNode(_component_ion_segment_button, {
                          mode: "md",
                          onClick: _cache[14] || (_cache[14] = ($event: any) => ($setup.updateShapeSize('normal'))),
                          disabled: $setup.canvas.isResizing
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_icon, { icon: $setup.contract }, null, 8, ["icon"]),
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [
                                _hoisted_10
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["disabled"]), [
                          [_vShow, !['副花', '寵物'].includes($setup.canvas.selectedShape.type) && $setup.canvas.selectedShape.name != '木名牌' && $setup.canvas.selectedShape.size == 'large']
                        ]),
                        _withDirectives(_createVNode(_component_ion_segment_button, {
                          mode: "md",
                          onClick: _cache[15] || (_cache[15] = ($event: any) => ($setup.updateShapeSize('large'))),
                          disabled: $setup.canvas.isResizing
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_icon, { icon: $setup.expand }, null, 8, ["icon"]),
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [
                                _hoisted_11
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["disabled"]), [
                          [_vShow, !['副花', '寵物'].includes($setup.canvas.selectedShape.type) && $setup.canvas.selectedShape.name != '木名牌' && $setup.canvas.selectedShape.size != 'large']
                        ]),
                        _createVNode(_component_ion_segment_button, {
                          mode: "md",
                          onClick: _cache[16] || (_cache[16] = ($event: any) => ($setup.moveSelectedShape('up')))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_icon, { icon: $setup.chevronUp }, null, 8, ["icon"]),
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [
                                _hoisted_12
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_segment_button, {
                          mode: "md",
                          onClick: _cache[17] || (_cache[17] = ($event: any) => ($setup.moveSelectedShape('down')))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_icon, { icon: $setup.chevronDown }, null, 8, ["icon"]),
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [
                                _hoisted_13
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _withDirectives(_createVNode(_component_ion_segment_button, {
                          mode: "md",
                          onClick: _cache[18] || (_cache[18] = ($event: any) => ($setup.setShapeVisible($setup.canvas.selectedShape, true)))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_icon, { icon: $setup.eyeOutline }, null, 8, ["icon"]),
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [
                                _hoisted_14
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 512), [
                          [_vShow, $setup.canvas.selectedShape.type == '寵物' && $setup.canvas.selectedShape.visible == false]
                        ]),
                        _withDirectives(_createVNode(_component_ion_segment_button, {
                          mode: "md",
                          onClick: _cache[19] || (_cache[19] = ($event: any) => ($setup.setShapeVisible($setup.canvas.selectedShape, false)))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_icon, { icon: $setup.eyeOffOutline }, null, 8, ["icon"]),
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [
                                _hoisted_15
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 512), [
                          [_vShow, $setup.canvas.selectedShape.type == '寵物' && $setup.canvas.selectedShape.visible != false]
                        ]),
                        _withDirectives(_createVNode(_component_ion_segment_button, {
                          mode: "md",
                          onClick: _cache[20] || (_cache[20] = ($event: any) => ($setup.removeShape($setup.canvas.selectedShape.id, true)))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_icon, { icon: $setup.trashOutline }, null, 8, ["icon"]),
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [
                                _hoisted_16
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 512), [
                          [_vShow, $setup.canvas.selectedShape.type != '寵物']
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue"]), [
                      [_vShow, !$setup.viewOnly]
                    ])
                  ])
                ]),
                _: 1
              }, 512), [
                [_vShow, $setup.canvas.selectedShape.id]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_modal, {
            "is-open": $setup.isPriceModalOpened,
            onDidDismiss: _cache[25] || (_cache[25] = ($event: any) => ($setup.isPriceModalOpened = false))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_header, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_toolbar, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_buttons, { slot: "start" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_button, {
                            slot: "icon-only",
                            onClick: _cache[23] || (_cache[23] = ($event: any) => ($setup.isPriceModalOpened = false))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, { icon: $setup.close }, null, 8, ["icon"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_title, null, {
                        default: _withCtx(() => [
                          _createTextVNode("價錢：HK$" + _toDisplayString($setup.getOrderItemTotal().toLocaleString()), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_button, {
                        slot: "end",
                        color: "tertiary",
                        onClick: _cache[24] || (_cache[24] = ($event: any) => ($setup.isPriceModalOpened = false)),
                        "router-link": {
              name: 'CheckoutPage',
              params: { passedCartItems: JSON.stringify([{
                canvas: $setup.getDBCanvasData(), // bottle / pet / shape info
                designId: $setup.design.id || '',
                designName: $setup.design.name || '手作寵物LED保鮮花瓶',
                designDataURL: $setup.getCanvasDataURL(),
                unitPrice: $setup.getOrderItemTotal(),
                quantity: 1,
                bottleId: $setup.design.bottle ? $setup.design.bottle.id : '',
                numOfPets: $setup.design.numOfPets,
                pet1: $setup.design.pet1,
                pet2: $setup.design.pet2,
                pet3: $setup.design.pet3,
              }]) }
            }
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString($setup.t('buyNow')) + " ", 1),
                          _createVNode(_component_ion_icon, {
                            slot: "end",
                            icon: $setup.arrowForward
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }, 8, ["router-link"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_content, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.getGroupedCanvasShapes(), (value, type) => {
                    return (_openBlock(), _createBlock(_component_ion_list, { key: type }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_list_header, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [
                                _createElementVNode("h2", null, [
                                  _createElementVNode("b", null, _toDisplayString(type) + " (HK$" + _toDisplayString(value.totalPrice) + ")", 1)
                                ])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value.groupedShapes, (value, shapeId) => {
                          return (_openBlock(), _createBlock(_component_ion_item, { key: shapeId }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_thumbnail, { slot: "start" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("img", {
                                    style: {"object-fit":"contain"},
                                    src: value.shapes[0].photoLink
                                  }, null, 8, _hoisted_17)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("h3", null, [
                                    _createElementVNode("b", null, _toDisplayString(value.shapes.length) + " x " + _toDisplayString(value.shapes[0].name) + _toDisplayString(value.shapes[0].size == 'large' ? ' (大)' : ""), 1)
                                  ]),
                                  _withDirectives(_createElementVNode("p", { style: {"white-space":"pre-line"} }, _toDisplayString($setup.canvas.namePlateText), 513), [
                                    [_vShow, value.shapes[0].name == '木名牌']
                                  ]),
                                  _withDirectives(_createElementVNode("p", null, "總計：HK$" + _toDisplayString(value.totalPrice), 513), [
                                    [_vShow, value.totalPrice != null]
                                  ])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 2
                    }, 1024))
                  }), 128)),
                  _hoisted_18,
                  _hoisted_19,
                  _hoisted_20,
                  _hoisted_21,
                  _hoisted_22
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["is-open"]),
          _createVNode(_component_ion_modal, {
            "is-open": $setup.isSubmitDesignModalOpened,
            onDidDismiss: _cache[30] || (_cache[30] = ($event: any) => ($setup.isSubmitDesignModalOpened = false))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_header, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_toolbar, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_buttons, { slot: "start" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_button, {
                            slot: "icon-only",
                            onClick: _cache[26] || (_cache[26] = ($event: any) => ($setup.isSubmitDesignModalOpened = false))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, { icon: $setup.close }, null, 8, ["icon"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_title, null, {
                        default: _withCtx(() => [
                          _hoisted_23
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_content, null, {
                default: _withCtx(() => [
                  _createElementVNode("form", {
                    class: "ion-text-center",
                    onSubmit: _cache[29] || (_cache[29] = _withModifiers(($event: any) => ($setup.submitDesign()), ["prevent"]))
                  }, [
                    _createElementVNode("p", null, [
                      _createElementVNode("img", { src: $setup.currDesignDataURL }, null, 8, _hoisted_24)
                    ]),
                    _createVNode(_component_ion_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_col, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_list, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_item, { fill: "outline" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_icon, {
                                      icon: $setup.personCircle,
                                      slot: "start"
                                    }, null, 8, ["icon"]),
                                    _createVNode(_component_ion_label, { position: "stacked" }, {
                                      default: _withCtx(() => [
                                        _hoisted_25
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_input, {
                                      type: "text",
                                      modelValue: $setup.applicant.name,
                                      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (($setup.applicant.name) = $event)),
                                      required: ""
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_item, {
                                  class: "ion-margin-top",
                                  fill: "outline"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_icon, {
                                      icon: $setup.call,
                                      slot: "start"
                                    }, null, 8, ["icon"]),
                                    _createVNode(_component_ion_label, { position: "stacked" }, {
                                      default: _withCtx(() => [
                                        _hoisted_26
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_input, {
                                      inputmode: "numeric",
                                      modelValue: $setup.applicant.phone,
                                      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (($setup.applicant.phone) = $event)),
                                      required: ""
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createElementVNode("p", null, [
                      _createVNode(_component_ion_button, {
                        type: "submit",
                        shape: "round",
                        fill: "outline"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_27,
                          _createVNode(_component_ion_icon, {
                            slot: "end",
                            icon: $setup.sendOutline
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      })
                    ])
                  ], 32)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["is-open"]),
          _createVNode(_component_ion_grid, { fixed: "" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_28, null, 512),
              ($setup.loadingCanvas || $setup.loadingUserDesigns)
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    _createVNode(_component_ion_spinner),
                    _hoisted_30
                  ]))
                : (_openBlock(), _createBlock(_component_ion_row, {
                    key: 1,
                    class: "ion-justify-content-center ion-text-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, {
                        class: "sticky",
                        "size-xs": "12",
                        "size-md": "12",
                        "size-lg": "12"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_31, [
                            _createVNode(_component_v_stage, {
                              ref: "stageRef",
                              config: { width: $setup.sceneWidth, height: $setup.sceneHeight },
                              onMousedown: $setup.handleStageMouseDown,
                              onTouchstart: $setup.handleStageMouseDown
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_layer, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_rect, {
                                      config: {
                    x: 0,
                    y: 0,
                    width: $setup.sceneWidth,
                    height: $setup.sceneHeight,
                    fill: 'white',
                  }
                                    }, null, 8, ["config"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_layer, {
                                  ref: "bottleLayerRef",
                                  config: { name: 'bottleLayer' }
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_image, {
                                      config: {
                    width: $setup.canvas.bottleWidth,
                    height: $setup.canvas.bottleHeight,
                    x: 0,
                    y: 0,
                    image: $setup.canvas.bottleImage
                  }
                                    }, null, 8, ["config"]),
                                    _createVNode(_component_v_image, {
                                      config: {
                    width: $setup.canvas.grassWidth,
                    height: $setup.canvas.grassHeight,
                    x: $setup.canvas.bottleWidth / 2 - $setup.canvas.grassWidth / 2,
                    y: $setup.canvas.bottleHeight - $setup.canvas.grassHeight - $setup.canvas.bottleBaseHeight,
                    image: $setup.canvas.grassImage
                  }
                                    }, null, 8, ["config"])
                                  ]),
                                  _: 1
                                }, 512),
                                _createVNode(_component_v_layer, {
                                  ref: "flowerLayerRef",
                                  config: { name: 'flowerLayer' }
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.getOrderedCanvasShapes(), (s) => {
                                      return (_openBlock(), _createBlock(_component_v_group, {
                                        key: s.id,
                                        onTransformend: ($event: any) => (s.name == '木名牌' ? $setup.handleTransformEnd : null),
                                        config: s.name == '木名牌' ? {
                      type: s.type,
                      id: s.id,
                      x: (s.x || (s.width || $setup.canvas.bottleWidth * 0.3) / 2),
                      y: (s.y || (s.height || $setup.canvas.bottleHeight * 0.3) / 2),
                      visible: s.visible != false && $setup.canvas.layerVisibility[s.type],
                      listening: (s.type == '寵物' || $setup.viewOnly || ($setup.canvas.lockMoveSelectedShape && s.id != $setup.canvas.selectedShape.id)) ? false : true,
                      draggable: (s.type == '寵物' || $setup.viewOnly) ? false : true,
                    } : {}
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_image, {
                                            onMouseenter: $setup.handleMouseEnter,
                                            onMouseleave: $setup.handleMouseLeave,
                                            onTransformend: $setup.handleTransformEnd,
                                            config: s.name == '木名牌' ? {
                          id: s.id,
                          width: (s.width || $setup.canvas.bottleWidth * 0.3),
                          height: (s.height || $setup.canvas.bottleHeight * 0.3),
                          rotation: s.rotation,
                          scaleX: s.scaleX,
                          scaleY: s.scaleY,
                          image: s.loadedImg,
                          name: s.name,
                          ...$setup.getShapeAttrObj(s),
                        } : {
                          type: s.type,
                          id: s.id,
                          width: s.type == '寵物' ? (s.width || $setup.canvas.petWidth) : (s.width || $setup.canvas.bottleWidth * 0.3),
                          height: s.type == '寵物' ? (s.height || $setup.canvas.petHeight) : (s.height || $setup.canvas.bottleHeight * 0.3),
                          x: s.type == '寵物' ? $setup.getPetCanvasX(s) : (s.x || (s.width || $setup.canvas.bottleWidth * 0.3) / 2),
                          y: s.type == '寵物' ? $setup.getPetCanvasY(s) : (s.y || (s.height || $setup.canvas.bottleHeight * 0.3) / 2),
                          rotation: s.rotation,
                          scaleX: s.scaleX,
                          scaleY: s.scaleY,
                          image: s.loadedImg,
                          name: s.name,
                          visible: s.visible != false && $setup.canvas.layerVisibility[s.type],
                          listening: (s.type == '寵物' || $setup.viewOnly || ($setup.canvas.lockMoveSelectedShape && s.id != $setup.canvas.selectedShape.id)) ? false : true,
                          draggable: (s.type == '寵物' || $setup.viewOnly) ? false : true,
                          ...$setup.getShapeAttrObj(s),
                        }
                                          }, null, 8, ["onMouseenter", "onMouseleave", "onTransformend", "config"]),
                                          (s.name == '木名牌')
                                            ? (_openBlock(), _createBlock(_component_v_text, {
                                                key: 0,
                                                config: {
                        width: (s.width || $setup.canvas.bottleWidth * 0.3), // 10 for fine-adjustment
                        height: (s.height || $setup.canvas.bottleHeight * 0.3) * 0.2, // 0.2 is the ratio of name text area
                        rotation: s.rotation,
                        id: $setup.canvas.namePlateTextId,
                        text: $setup.canvas.namePlateText,
                        fontSize: 8,
                        align: 'center',
                        verticalAlign: 'middle',
                      }
                                              }, null, 8, ["config"]))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 2
                                      }, 1032, ["onTransformend", "config"]))
                                    }), 128)),
                                    _createVNode(_component_v_transformer, {
                                      ref: "transformer",
                                      onDragend: $setup.handleTrDragEnd,
                                      config: {
                    keepRatio: true,
                    resizeEnabled: false,
                    rotationSnaps: [0, 90, 180, 270],
                    centeredScaling: true,
                    enabledAnchors: [],
                    boundBoxFunc: $setup.boundBoxFunc,
                    anchorStrokeWidth: 3,
                    anchorCornerRadius: 25,
                    anchorSize: 25,
                    rotateAnchorOffset: 20,
                    useSingleNodeRotation: false,
                  }
                                    }, null, 8, ["onDragend", "config"])
                                  ]),
                                  _: 1
                                }, 512),
                                _createVNode(_component_v_layer, { config: { name: 'helperLayer' } }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_image, {
                                      config: {
                    width: $setup.canvas.bottleWidth,
                    height: $setup.canvas.bottleWidth / 4.79,
                    x: 0,
                    y: $setup.canvas.bottleHeight - $setup.canvas.bottleWidth / 4.79,
                    image: $setup.canvas.croppedBottleBaseImage
                  }
                                    }, null, 8, ["config"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["config", "onMousedown", "onTouchstart"])
                          ], 512),
                          ($setup.canvas.selectedShape.id)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                _createVNode(_component_ion_text, null, {
                                  default: _withCtx(() => [
                                    _createElementVNode("b", null, _toDisplayString($setup.canvas.lockMoveSelectedShape ? '已指定移動：' : '') + _toDisplayString($setup.getSelectedShapeName($setup.canvas.selectedShape)), 1)
                                  ]),
                                  _: 1
                                }),
                                _hoisted_33,
                                _withDirectives(_createVNode(_component_ion_button, {
                                  size: "small",
                                  shape: "round",
                                  onClick: _cache[31] || (_cache[31] = ($event: any) => ($setup.canvas.lockMoveSelectedShape = false)),
                                  fill: "outline"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_icon, {
                                      slot: "start",
                                      icon: $setup.lockOpenOutline
                                    }, null, 8, ["icon"]),
                                    _hoisted_34
                                  ]),
                                  _: 1
                                }, 512), [
                                  [_vShow, $setup.canvas.lockMoveSelectedShape]
                                ]),
                                _withDirectives(_createVNode(_component_ion_button, {
                                  size: "small",
                                  shape: "round",
                                  onClick: _cache[32] || (_cache[32] = ($event: any) => ($setup.canvas.lockMoveSelectedShape = true))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_icon, {
                                      slot: "start",
                                      icon: $setup.lockClosedOutline
                                    }, null, 8, ["icon"]),
                                    _hoisted_35
                                  ]),
                                  _: 1
                                }, 512), [
                                  [_vShow, !$setup.canvas.lockMoveSelectedShape]
                                ])
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                _createVNode(_component_ion_chip, {
                                  onClick: _cache[33] || (_cache[33] = ($event: any) => ($setup.toggleLayerVisibility('寵物'))),
                                  outline: !$setup.canvas.layerVisibility['寵物']
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_label, null, {
                                      default: _withCtx(() => [
                                        _hoisted_37
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_icon, {
                                      icon: $setup.canvas.layerVisibility['寵物'] ? $setup.eyeOutline : $setup.eyeOffOutline
                                    }, null, 8, ["icon"])
                                  ]),
                                  _: 1
                                }, 8, ["outline"]),
                                _createVNode(_component_ion_chip, {
                                  onClick: _cache[34] || (_cache[34] = ($event: any) => ($setup.toggleLayerVisibility('主花'))),
                                  outline: !$setup.canvas.layerVisibility['主花']
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_label, null, {
                                      default: _withCtx(() => [
                                        _hoisted_38
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_icon, {
                                      icon: $setup.canvas.layerVisibility['主花'] ? $setup.eyeOutline : $setup.eyeOffOutline
                                    }, null, 8, ["icon"])
                                  ]),
                                  _: 1
                                }, 8, ["outline"]),
                                _createVNode(_component_ion_chip, {
                                  onClick: _cache[35] || (_cache[35] = ($event: any) => ($setup.toggleLayerVisibility('副花'))),
                                  outline: !$setup.canvas.layerVisibility['副花']
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_label, null, {
                                      default: _withCtx(() => [
                                        _hoisted_39
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_icon, {
                                      icon: $setup.canvas.layerVisibility['副花'] ? $setup.eyeOutline : $setup.eyeOffOutline
                                    }, null, 8, ["icon"])
                                  ]),
                                  _: 1
                                }, 8, ["outline"])
                              ])),
                          _withDirectives(_createElementVNode("div", _hoisted_40, null, 512), [
                            [_vShow, !$setup.viewOnly]
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, {
                        "size-xs": "12",
                        "size-md": "12",
                        "size-lg": "12"
                      }, {
                        default: _withCtx(() => [
                          _withDirectives(_createElementVNode("div", _hoisted_41, [
                            _createVNode(_component_ion_toolbar, {
                              class: "grey-bg",
                              style: {"--min-height":"24px"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_buttons, { slot: "start" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_button, {
                                      color: "primary",
                                      onClick: _cache[36] || (_cache[36] = ($event: any) => ($setup.undo())),
                                      disabled: $setup.appHistory.step == -1
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_icon, {
                                          slot: "icon-only",
                                          icon: $setup.arrowUndoOutline
                                        }, null, 8, ["icon"])
                                      ]),
                                      _: 1
                                    }, 8, ["disabled"]),
                                    _createVNode(_component_ion_button, {
                                      color: "primary",
                                      onClick: _cache[37] || (_cache[37] = ($event: any) => ($setup.redo())),
                                      disabled: $setup.appHistory.states.length == 0 || $setup.appHistory.step >= $setup.appHistory.states.length-1
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_icon, {
                                          slot: "icon-only",
                                          icon: $setup.arrowRedoOutline
                                        }, null, 8, ["icon"])
                                      ]),
                                      _: 1
                                    }, 8, ["disabled"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_button, {
                                  class: "ion-hide-sm-up",
                                  color: "medium",
                                  fill: "clear",
                                  style: {"height":"24px"},
                                  onClick: _cache[38] || (_cache[38] = ($event: any) => ($setup.scrollToRefElement($setup.shapePanelRef)))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_icon, {
                                      class: "icon-lg",
                                      slot: "icon-only",
                                      icon: $setup.remove
                                    }, null, 8, ["icon"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_toolbar, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_segment, {
                                  onIonChange: _cache[39] || (_cache[39] = ($event: any) => ($setup.selectedPanelShape = {})),
                                  class: "sections",
                                  modelValue: $setup.selectedSectionTab,
                                  "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => (($setup.selectedSectionTab) = $event)),
                                  scrollable: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_segment_button, {
                                      style: {"--background":"var(--ion-color-primary)","--color":"#fff"},
                                      value: "已選"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_label, null, {
                                          default: _withCtx(() => [
                                            _hoisted_42
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_segment_button, { value: "主花" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_label, null, {
                                          default: _withCtx(() => [
                                            _hoisted_43
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_segment_button, { value: "副花" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_label, null, {
                                          default: _withCtx(() => [
                                            _hoisted_44
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_segment_button, { value: "草皮" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_label, null, {
                                          default: _withCtx(() => [
                                            _hoisted_45
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_segment_button, { value: "裝飾品" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_label, null, {
                                          default: _withCtx(() => [
                                            _hoisted_46
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_popover, {
                              class: "color-popover",
                              "is-open": $setup.isColorPopoverOpenRef,
                              event: $setup.colorPopoverEvent,
                              showBackdrop: true,
                              side: "top",
                              onDidDismiss: _cache[41] || (_cache[41] = ($event: any) => ($setup.isColorPopoverOpenRef = false)),
                              "dismiss-on-select": true
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_47, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.selectedPanelShape.colors, (color, i) => {
                                    return (_openBlock(), _createBlock(_component_ion_button, {
                                      key: i,
                                      onClick: ($event: any) => ($setup.addFlowerToCanvas($setup.selectedPanelShape, color)),
                                      style: _normalizeStyle(`--background: ${color.colorHex}`),
                                      size: "small",
                                      shape: "round"
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_48
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick", "style"]))
                                  }), 128))
                                ])
                              ]),
                              _: 1
                            }, 8, ["is-open", "event"]),
                            _createElementVNode("div", _hoisted_49, [
                              _withDirectives(_createElementVNode("div", null, [
                                _createVNode(_component_draggable, {
                                  class: "draggable-container",
                                  list: $setup.canvas.panelShapes,
                                  onChange: $setup.doShapeReorder,
                                  onChoose: $setup.onChooseElement,
                                  delay: 100,
                                  delayOnTouchOnly: true
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.canvas.panelShapes, (shape, i) => {
                                      return (_openBlock(), _createBlock(_component_ion_col, {
                                        "size-xs": "4",
                                        "size-md": "3",
                                        class: "ion-no-padding ion-text-center grey-bg",
                                        key: shape.id
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_card, {
                                            class: _normalizeClass(["flower-card", { 'hidden-shape': !shape.visible }]),
                                            onClick: ($event: any) => ($setup.setCanvasSelectedShape(shape, true, false)),
                                            color: $setup.canvas.selectedShape.id == shape.id ? 'primary' : ''
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_badge, {
                                                class: "top-left-badge normal-text",
                                                color: "medium"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(i+1), 1)
                                                ]),
                                                _: 2
                                              }, 1024),
                                              _createElementVNode("img", {
                                                src: shape.photoLink
                                              }, null, 8, _hoisted_50),
                                              _hoisted_51,
                                              _createVNode(_component_ion_text, { class: "flower-text normal-text" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(shape.name), 1)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick", "color", "class"])
                                        ]),
                                        _: 2
                                      }, 1024))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["list", "onChange", "onChoose"])
                              ], 512), [
                                [_vShow, $setup.selectedSectionTab == '已選']
                              ]),
                              _withDirectives(_createVNode(_component_ion_row, null, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.flowers, (flower) => {
                                    return _withDirectives((_openBlock(), _createBlock(_component_ion_col, {
                                      "size-xs": "4",
                                      "size-md": "3",
                                      class: "ion-no-padding ion-text-center grey-bg",
                                      key: flower.id
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_card, {
                                          class: _normalizeClass(["flower-card", { 'highlight-card': $setup.selectedPanelShape.id == flower.id }]),
                                          onClick: ($event: any) => ($setup.addFlowerToCanvas(flower, null, $event)),
                                          button: ""
                                        }, {
                                          default: _withCtx(() => [
                                            ((new Date() - new Date(flower.createdAt)) / (1000*60*60*24) < 30)
                                              ? (_openBlock(), _createBlock(_component_ion_badge, {
                                                  key: 0,
                                                  style: {"letter-spacing":"normal"},
                                                  class: "sale-badge",
                                                  color: "danger"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString($setup.t('new')), 1)
                                                  ]),
                                                  _: 1
                                                }))
                                              : _createCommentVNode("", true),
                                            _createElementVNode("img", {
                                              src: flower.photoLink
                                            }, null, 8, _hoisted_52),
                                            _hoisted_53,
                                            _createVNode(_component_ion_text, { class: "flower-text" }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(flower.name), 1)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1032, ["class", "onClick"])
                                      ]),
                                      _: 2
                                    }, 1024)), [
                                      [_vShow, flower.type == $setup.selectedSectionTab && (!flower.showInBottles || flower.showInBottles.includes($setup.design.bottle.id))]
                                    ])
                                  }), 128))
                                ]),
                                _: 1
                              }, 512), [
                                [_vShow, $setup.selectedSectionTab != '已選']
                              ])
                            ])
                          ], 512), [
                            [_vShow, !$setup.viewOnly]
                          ]),
                          _createElementVNode("div", _hoisted_54, [
                            _createVNode(_component_ion_icon, {
                              size: "large",
                              slot: "icon-only",
                              icon: $setup.chevronUp,
                              onClick: _cache[42] || (_cache[42] = ($event: any) => ($setup.updateSelectedShape('prev')))
                            }, null, 8, ["icon"]),
                            _withDirectives(_createElementVNode("div", _hoisted_55, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.canvas.panelShapes, (shape, i) => {
                                return (_openBlock(), _createBlock(_component_ion_card, {
                                  class: _normalizeClass(["ion-text-center", { 'hidden-shape': !shape.visible }]),
                                  key: shape.id,
                                  onClick: ($event: any) => ($setup.setCanvasSelectedShape(shape, true, false)),
                                  color: $setup.canvas.selectedShape.id == shape.id ? 'primary' : '',
                                  ref_for: true,
                                  ref: el => { $setup.vBarShapeBtns[i] = el }
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_thumbnail, null, {
                                      default: _withCtx(() => [
                                        _createElementVNode("img", {
                                          style: {"object-fit":"contain"},
                                          src: shape.photoLink
                                        }, null, 8, _hoisted_56)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick", "color", "class"]))
                              }), 128))
                            ], 512), [
                              [_vShow, !$setup.viewOnly & $setup.canvas.panelShapes.length > 0]
                            ]),
                            _createVNode(_component_ion_icon, {
                              size: "large",
                              slot: "icon-only",
                              icon: $setup.chevronDown,
                              onClick: _cache[43] || (_cache[43] = ($event: any) => ($setup.updateSelectedShape('next')))
                            }, null, 8, ["icon"])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}